"use strict";
"use client";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SciChartGroupContext = void 0;
const react_1 = require("react");
/** The context provided within a {@link SciChartGroup} */
exports.SciChartGroupContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=SciChartGroupContext.js.map